import { i18n } from '@/plugins/i18n'
import { shRequestStatusStr } from '@/constants/shaparakRequestStatus'
import { shRequestVariant } from '@/constants/shaparakRequestStatus'
import RejectionReasonsColumn from "../components/rejection-reasons";

const rejectionReasonTemplate = (row, index, datatable) => {
    let template = new RejectionReasonsColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'request_type',
        title: i18n.t('shaparakRequests.request_type'),
        sortable: false,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('shaparakRequests.status'),
        textAlign: 'center',
        template: (row) => {
            let status  = shRequestStatusStr.get(row.status)
            let variant = 'badge-'+shRequestVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        sortable: false,
        width: 90,
    },
    {
        field: 'created_at',
        title: i18n.t('shaparakRequests.created_at'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'rejection_reason',
        title: i18n.t('shaparakRequests.description'),
        sortable: false,
        width: 80,
        template: (row, index, datatable) => {
            return rejectionReasonTemplate(row, index, datatable)
        },
        textAlign: 'center',
    },

]